<script>
import { CdrText } from '@rei/cedar';
import { currencyFormatter } from '../../../utils/formatCurrency';

export default {
  name: 'LandingPriceComponent',
  components: {
    CdrText,
  },
  props: {
    highestPrice: { type: Number, required: true, default: 0 },
    lowestPrice: { type: Number, required: true, default: 0 },
    fullPrice: { type: Number, required: true, default: 0 },
    percentOff: { type: Number, required: true, default: 0 },
    sale: { type: Boolean, required: true, default: false },
  },
  computed: {
    formattedLowestPrice() {
      return currencyFormatter.format(this.lowestPrice);
    },
    formattedHighestPrice() {
      return currencyFormatter.format(this.highestPrice);
    },
    isFullSale() {
      return this.highestPrice !== this.fullPrice;
    },
    comparePrice() {
      if (this.sale && this.highestPrice !== this.fullPrice) {
        return currencyFormatter.format(this.fullPrice);
      }
      return false;
    },
  },
};
</script>
<template>
  <div class="price-component">
    <cdr-text
      data-ui="price-component-price"
      :class="['price-component__price', { 'is-sale': isFullSale }]"
    >
      <!-- If price range -->
      <span
        data-ui="price-component-lowest-price"
        :class="[{ 'is-sale': sale }]"
      >{{ formattedLowestPrice }}</span>

      <!-- If no price range-->
      <span
        v-if="lowestPrice !== highestPrice"
      > &#8211; {{ formattedHighestPrice }}</span>
    </cdr-text>

    <!-- If compare price -->
    <cdr-text
      v-if="comparePrice"
      data-ui="price-component-compare-price"
      class="price-component__price"
    >
      <span class="sr-only">Compared to </span>
      <span class="price-component__compare-price">{{ comparePrice }}</span>
    </cdr-text>

    <cdr-text
      v-if="percentOff && percentOff > 0"
      class="price-component__percent-off"
    >
      Save up to {{ percentOff }}% Off
    </cdr-text>
  </div>
</template>
<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
.price-component {
  &__price {
    @include cdr-text-utility-sans-400;
    display: inline;

    & + & {
      margin-left: 6px;
    }
  }
  .is-sale {
    color: $cdr-color-text-sale;
  }

  &__compare-price {
    text-decoration: line-through;
  }

  &__percent-off {
    @include cdr-text-utility-sans-200;
    margin-top: 4px;
    color: $cdr-color-text-secondary;
  }

  .sr-only {
    @include cdr-display-sr-only;
  }
}
</style>
